export default __webpack_public_path__ + "static/media/cancel-white.a0adc100.svg";